__turbopack_context__.v({
  "img": "klab-logo-module__Eiel8G__img",
  "inner": "klab-logo-module__Eiel8G__inner",
  "objectContain": "klab-logo-module__Eiel8G__objectContain",
  "objectCover": "klab-logo-module__Eiel8G__objectCover",
  "objectFill": "klab-logo-module__Eiel8G__objectFill",
  "root": "klab-logo-module__Eiel8G__root",
});
